function readStoredToken() {
  try {
    let user = JSON.parse(localStorage.getItem('user'));
    return user && user.accessToken ? user.accessToken : null;
  } catch (e) {
    // Beschädigter Eintrag: aufräumen statt bei jedem Request erneut zu scheitern.
    localStorage.removeItem('user');
    return null;
  }
}

// Prüft das exp-Claim des Tokens. Ein abgelaufenes Token gar nicht erst zu senden
// spart dem Server die Ablehnung und dem Client eine sinnlose Fehlerbehandlung.
function isExpired(token) {
  var parts = token.split('.');
  if (parts.length !== 3) {
    return true;
  }
  try {
    var payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
  } catch (e) {
    return true;
  }
}

export function clearStoredUser() {
  localStorage.removeItem('user');
}

export default function authHeader() {
  let token = readStoredToken();
  if (!token) {
    return {};
  }
  if (isExpired(token)) {
    clearStoredUser();
    return {};
  }
  return { Authorization: 'Bearer ' + token };
}
